import { messagesNow } from '@/i18n'
import { messages } from './messages'

type Messages = (typeof messages)['ru']
type Text = (m: Messages) => string

const FAILED = new Map<string, Text>([
  ['content_changed', (m) => m.failedContentChanged],
  ['cancelled', (m) => m.failedCancelled],
  ['stalled', (m) => m.failedStalled],
])

export const failedReviewText = (code: string | null): string => {
  const m = messagesNow(messages)
  return (code !== null ? FAILED.get(code)?.(m) : undefined) ?? m.failedDefault
}

const CATEGORY = new Map<string, Text>([
  ['gambling', (m) => m.catGambling],
  ['scam_or_pyramid', (m) => m.catScam],
  ['guaranteed_income', (m) => m.catGuaranteedIncome],
  ['adult', (m) => m.catAdult],
  ['drugs', (m) => m.catDrugs],
  ['violence_or_extremism', (m) => m.catViolence],
  ['hate', (m) => m.catHate],
  ['politics', (m) => m.catPolitics],
  ['third_party_promo', (m) => m.catThirdPartyPromo],
  ['personal_data', (m) => m.catPersonalData],
  ['moderation_manipulation', (m) => m.catManipulation],
  ['provider_safety_block', (m) => m.catProviderSafety],
  ['external_image', (m) => m.catExternalImage],
  ['image_unavailable', (m) => m.catImageUnavailable],
])
export const categoryText = (c: string): string => CATEGORY.get(c)?.(messagesNow(messages)) ?? c
